import {
  ASSIGMENTS_ORDER_REMOVE_DOCUMENT,
  ASSIGMENTS_ORDER_REMOVE_DOCUMENT_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const removeAssignmentDocumentAction = (params) => async (dispatch) => {
  const { legal_id, order_id, document_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.delete(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/documents/${document_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'delete',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_REMOVE_DOCUMENT,
    });

    return data || {};
  } catch (e) {
    dispatch({
      method: 'delete',
      payload: e || {},
      type: ASSIGMENTS_ORDER_REMOVE_DOCUMENT_ERROR,
    });
  }
};
